import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";

import { useCopyLinkToClipboard } from "@/react/hooks/useCopyLinkToClipboard";

import {
  AI_VIEW_DEFAULT,
  AI_VIEW_FULLSCREEN,
  buildCircleAiEntryUrl,
} from "../../intents/urlParams";

/**
 * Reads the copy strings directly rather than through
 * `ConversationActionsProvider`, which the new-conversation menu has no
 * instance of; the provider hands out the same object anyway.
 */
export const useCopyCircleAiLink = () => {
  const conversationPanelState = useCircleAIShellStore(
    s => s.conversationPanelState,
  );
  const copyLinkToClipboard = useCopyLinkToClipboard();

  // The copied link reopens at the width it was copied from.
  return (conversationId: string | null) => {
    const view =
      conversationPanelState === "fullscreen"
        ? AI_VIEW_FULLSCREEN
        : AI_VIEW_DEFAULT;
    copyLinkToClipboard(buildCircleAiEntryUrl(conversationId, view));
  };
};
